<template>
  <div class="benchmarking-container">
    <div class="benchmarking-header">
      <h2>Coming Soon</h2>
      <p class="benchmarking-description">
        Benchmark and profile your models on a wide selection of edge platforms and analyze performance.
      </p>
    </div>

    <div class="benchmarking-images">
      <div class="image-wrapper">
        <img src="@/assets/img/marketing/charts.png" alt="Performance charts" class="benchmarking-image" />
      </div>
      <div class="image-wrapper">
        <img src="@/assets/img/marketing/trace.png" alt="Performance trace" class="benchmarking-image" />
      </div>
    </div>

    <div class="benchmarking-footer">
      <button class="register-button" @click="handleRegisterClick">
        Register to get release notification
      </button>
    </div>

    <!-- Contact Us Dialog -->
    <ContactFormLanding
      v-if="showContactDialog"
      :initial-subject="'Benchmarking info register'"
      :initial-message="'I want to register to get release information of profiling and benchmarking tool'"
      @close="showContactDialog = false"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import ContactFormLanding from '@/components/ContactFormLanding.vue'

const showContactDialog = ref(false)

function handleRegisterClick() {
  showContactDialog.value = true
}
</script>

<!-- Benchmarking dialog state is managed locally here -->

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

.benchmarking-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 40px;
  min-height: 100%;
  background: white;
  @include themify() {
    color: themed('body-text-color');
  }
}

.benchmarking-header {
  text-align: center;
  max-width: 600px;

  h2 {
    font-size: 2.5rem;
    font-weight: 700;
    margin: 0 0 16px 0;
    @include themify() {
      color: themed('body-text-color');
    }
  }

  .benchmarking-description {
    font-size: 1.5rem;
    line-height: 1.6;
    margin: 0;

    font-style: italic;
    color: blue;
    @include themify() {
      color: themed('color-primary');
    }
  }
}

.benchmarking-images {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  width: 100%;
  max-width: 900px;
}

.image-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  overflow: hidden;
  @include themify() {
    background: themed('color-white-600');
    border: 1px solid themed('card-border-color');
  }
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.benchmarking-image {
  width: 100%;
  height: auto;
  display: block;
  max-height: 400px;
  object-fit: cover;
}

.benchmarking-footer {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.register-button {
  padding: 12px 32px;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  @include themify() {
    background: themed('color-primary');
    color: white;

    &:hover {
      background: darken(themed('color-primary'), 10%);
      box-shadow: 0 4px 12px rgba(var(--color-primary-rgb), 0.3);
    }

    &:active {
      transform: scale(0.98);
    }
  }
}
</style>
